import { render, staticRenderFns } from "./SectionSchedule.vue?vue&type=template&id=a450336a&scoped=true"
import script from "./SectionSchedule.vue?vue&type=script&lang=ts"
export * from "./SectionSchedule.vue?vue&type=script&lang=ts"
import style0 from "./SectionSchedule.vue?vue&type=style&index=0&id=a450336a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a450336a",
  null
  
)

export default component.exports